import { type RefObject, useEffect, useRef } from 'react'

/**
 * `message` が現れた / 変わった時に、`ref` の要素が見える位置までスクロールする。
 *
 * 長いダイアログ・ページを下までスクロールして「保存」を押した時、欄に付かないエラー
 * (上部の Alert) が見えない位置に出て、保存しても反応が無いように見えるのを防ぐ。
 * 同じ文言のエラーが続けて出た場合は再スクロールしない (文言が変わった時だけ動く)。
 * jsdom など `scrollIntoView` を持たない環境では何もしない。
 */
export function useRevealOnChange<T extends HTMLElement>(
  message: string | undefined,
): RefObject<T> {
  const ref = useRef<T>(null)
  useEffect(() => {
    if (message === undefined) return
    ref.current?.scrollIntoView?.({ block: 'nearest' })
  }, [message])
  return ref
}
